import haskell from "refractor/haskell";
export default haskell;